<template>
  <custom-dialog
    width="1200px"
    :append-to-body="true"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    class="device-detail-conflict-route-dialog"
  >
    <div class="dialog-body">
      <el-form
        ref="form"
        :inline="true"
        label-position="left"
      >
        <div class="sel-route-content">
          <div class="container">
            <div class="device-list">
              <div
                class="device-item"
                v-for="(item,index) in listData"
                :key="index"
              >
                <div class="tips-top">
                  <div class="title">{{item.slotCode}}</div>
                  <i
                    v-if="del"
                    @click="onDel(item)"
                    class="icon icon-shanchu"
                  ></i>
                </div>
                <img
                  :src="item.url"
                  alt=""
                  class="img"
                  v-if="item.url"
                >
                <div class="tips-bottom">{{$momentLocal(item.gmtCreate)}}</div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button
        type="primary"
        @click="onConfirm"
      >
        {{ $t('Common.com_confirm') }}
      </el-button>
    </div>

  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {
  },
  props: {
    // 是否有删除权限
    del: Boolean,
  },
  data() {
    return {
      char: '',
      imgList: [],
      listData: [],
    };
  },
  computed: {
    info() {
      return this.model.data ? this.model.data : {};
    },
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    async onDel(data) {
      const row = data;
      const tips = 'cf_tips_del_selected_route';
      await this.$showConfirm(tips);
      const reqUrl = `${apis.hlcSlotDelete}/${row.hlcSlotId}`;
      await this.$postJSON(reqUrl);
      this.$message({
        message: this.$t('Common.com_delete_success'),
        type: 'success'
      });
      this.$emit('del');
      this.getTableList();
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.closeDialog();
    },
    formatList(list) {
      const ret = list.filter(item => item.slotCode === this.char);
      ret.forEach((item, index) => {

        // 获取图片
        if (item.mapId) {
          this.$getFileList({ bizId: item.mapId, bizType: 'i' }).then((fileList) => {
            if (fileList && fileList.length) {
              const curIndex = index;
              const file = fileList[0];
              if (curIndex >= 0) {
                this.$set(item, 'url', file.attachPath || file.url);
              }
            }
          });
        }
      });

      return ret;
    },
    getTableList() {
      const { productCode, siteId, hlcCode } = this.model.data;
      const reqUrl = `${apis.hlcSlotAppSoltList}/${productCode}/${siteId}/${hlcCode}`;

      this.$getJSON(reqUrl).then((res) => {
        if (!res.data) {
          res.data = [];
        }
        const list = res.data;
        const listData = this.formatList(list);
        this.listData = listData;
      });
    },
  },
  created() {
  },
  mounted() {
    this.getFuncView();
    this.char = this.model.data.slotCode;
    this.getTableList();
  },
};
</script>

<style lang="scss">
.device-detail-conflict-route-dialog {
  .val {
    font-size: 12px;
  }
  .img-container {
    width: 80px;
    height: 80px;
    position: relative;
    .img {
      width: 100%;
      height: 100%;
      // position: absolute;
      // max-width: 100%;
      // max-height: 100%;
      // left: 0;
      // right: 0;
      // top: 0;
      // bottom: 0;
      // margin: auto;
    }
  }

  .sel-route-content {
    &.empty {
      .container {
        .device-list {
          .device-item {
            .tips-top {
              background: transparent;
              .title {
                color: #202945;
              }
            }
          }
        }
      }
    }
    .title {
      line-height: 36px;
      font-size: 14px;
      font-weight: bold;
    }

    .container {
      .device-list {
        overflow: hidden;
        padding: 16px 0;

        .device-item {
          float: left;
          background: #fff;
          box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1) inset;
          margin-bottom: 32 * 0.5px;
          position: relative;
          border-radius: 4 * 0.5px;
          width: 200px;
          height: 150px;
          margin-right: 30px;
          overflow: hidden;

          &.active {
            box-shadow: 0 0 0 1px #00a0d9 inset;
          }

          .img {
            position: absolute;
            z-index: 0;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            margin: auto;
            max-width: 95%;
            max-height: 95%;
          }

          .tips-top {
            $h: 64 * 0.5px;
            height: $h;
            line-height: $h;
            font-size: 30 * 0.5px;
            background: rgba(77, 77, 77, 0.9);
            position: absolute;
            left: 0;
            width: 100%;
            z-index: 10;
            text-align: left;
            top: 0;
            padding: 0 16 * 0.5px;

            .title {
              float: left;
              line-height: $h;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #fff;
              max-width: 80%;
            }

            .icon {
              cursor: pointer;
            }

            .icon-shanchu {
              float: right;
              font-size: 14px;
              line-height: $h;
              color: #00a0d9;
            }
          }
          .tips-bottom {
            $h: 52 * 0.5px;
            height: $h;
            line-height: $h;
            font-size: 28 * 0.5px;
            text-align: center;
            position: absolute;
            left: 1px;
            right: 1px;
            z-index: 10;
            bottom: 1px;
            background: rgba(248, 248, 248, 0.9);
            color: #4d4d4d;
          }
        }
      }
    }
  }
}
</style>
